import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'semantic-ui-less/semantic.less';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
